import React from 'react'
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom'
import { getToken } from '../Services/GetToken'
import { connect } from 'react-redux'
import AppNavigation from '../Containers/AppNavigation'
import HomePage from '../Pages/HomePage'
import LoginPage from '../Pages/LoginPage'
import DestinationPage from '../Pages/DestinationPage'
import AttractionPage from '../Pages/AttractionPage'
import CouponPage from '../Pages/CouponPage'
import NotFound from '../Pages/NotFound'
import ProductPage from '../Pages/ProductPage'
import UserPage from '../Pages/UserPage'
import OrderPage from '../Pages/OrderPage'
import EventsPage from '../Pages/EventsPage'
import InsurancePage from '../Pages/InsurancePage'
import ManageAdminPage from '../Pages/ManageAdminPage'
import TravypassPage from '../Pages/TravypassPage'
import ReviewPage from '../Pages/ReviewPage'
import EcommercePage from '../Pages/EcommercePage'
import MiscPage from '../Pages/MiscPage'
import EsimPage from '../Pages/EsimPage'

const App = ({ auth, location }) => (
  <div>
    <BrowserRouter>
      <Switch>
        <PrivateRoute exact path='/' component={HomePage} auth={auth} location={location} />
        <PrivateRoute path='/destination/:sub?' component={DestinationPage} auth={auth} location={location} />
        <PrivateRoute path='/attractions/:sub?' component={AttractionPage} auth={auth} location={location} />
        <PrivateRoute path='/coupon/:sub?' component={CouponPage} auth={auth} location={location} />
        <PrivateRoute path='/product' component={ProductPage} auth={auth} location={location} />
        <PrivateRoute path='/esim' component={EsimPage} auth={auth} location={location} />
        <PrivateRoute path='/user/:sub?' component={UserPage} auth={auth} location={location} />
        <PrivateRoute path='/order/:sub?' component={OrderPage} auth={auth} location={location} />
        <PrivateRoute path='/e-commerce/:sub?' component={EcommercePage} auth={auth} location={location} />
        <PrivateRoute path='/events/:sub?' component={EventsPage} auth={auth} location={location} />
        <PrivateRoute path='/insurance/:sub?' component={InsurancePage} auth={auth} location={location} />
        <PrivateRoute path='/manage-admin' component={ManageAdminPage} auth={auth} location={location} />
        <PrivateRoute path='/reviews' component={ReviewPage} auth={auth} location={location} />
        <PrivateRoute path='/travypass/:sub?' component={TravypassPage} auth={auth} location={location} />
        <PrivateRoute path='/misc/:sub?' component={MiscPage} auth={auth} location={location} />
        <Route path='/login' component={LoginPage} />
        <Route component={NotFound} />
      </Switch>
    </BrowserRouter>
  </div>
)

let isAuthenticated = true

const checkAuth = () => {
  const token = getToken()
  token
    .then((res) => { isAuthenticated = true })
    .catch((err) => {
      isAuthenticated = false
      console.log('ERR_AUTH:', err)
    })
}

checkAuth()

const PrivateRoute = ({ component: Component, ...rest }) => (
  <AppNavigation location={rest.location}>
    <Route
      {...rest}
      render={
        props => {
          return (
            isAuthenticated
              ? <Component {...props} />
              : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
          )
        }
      }
    />
  </AppNavigation>
)

const stateToProps = (state) => ({
  auth: state.auth
})

const dispatchToProps = (dispatch) => ({})

export default connect(stateToProps, dispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/Routes/App.js